import { render, staticRenderFns } from "./BasicPolarArea.vue?vue&type=template&id=c5dd32e2&"
import script from "./BasicPolarArea.vue?vue&type=script&lang=js&"
export * from "./BasicPolarArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports